var UsageTypes = {
    'answering' : 0,
    'fiveG' : 1,
    'adsl' : 2,
    'cmc' : 3,
    'did' : 4,
    'efm' : 5,
    'fax' : 6,
    'fibre' : 7,
    'mbe' : 8,
    'mobile' : 9,
    'moh' : 10,
    'nbn' : 11,
    'nbnEnterprise' : 12,
    'sip' : 13,
    'teams' : 14,
    'voice' : 15,
    'voIP' : 16
}

function getValue(key) {
    return UsageTypes[key]
}

export { getValue }